







































































import moment from 'moment';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountObligateRequestModel from '@/models/bankaccounts/BankAccountObligateRequestModel';
import BankAccountObligateResponseModel from '@/models/bankaccounts/BankAccountObligateResponseModel';
import BankAccountFundResponseModel from '@/models/bankaccounts/BankAccountFundResponseModel';

@Component({
        name: 'BankAccountObligate',
    },
)
export default class BankAccountObligate extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public depositFundId: number = 0;
    public obligateAmount: string = '';
    public obligateDate: string = '';
    public obligateDateMenu: boolean = false;
    public obligateTo: number = 0;
    public authorized: boolean = false;

    public get depositFundBalance(): number {
        const depositFund = this.$store.state.selectedBankAccount.funds.find((x: BankAccountFundResponseModel) => x.isDepositFund);
        return depositFund.balance;
    }

    public get funds(): BankAccountFundResponseModel[] {
        return this.$store.state.selectedBankAccount.funds.filter((x: BankAccountFundResponseModel) => x.isDepositFund === false);
    }

    public obligateAmountRules(value: string): any {
        const result = this.amountRules(value, false);

        if ( result === true ) {
            if ( parseFloat(value) > this.depositFundBalance ) {
                return 'Amount may not exceed the deposit fund balance.';
            }

            return true;
        }
        else {
            return result;
        }
    }

    public obligateFundRules(value: number): any {
        if ( value === 0) {
            return 'A fund is required.';
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.OBLIGATE )
        {
            this.authorized = true;
            this.obligateDate = moment(new Date()).format('YYYY-MM-DD');
            this.depositFundId = this.$store.state.selectedBankAccount.funds.find((x: BankAccountFundResponseModel) => x.isDepositFund).fundId;
        }
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new BankAccountObligateRequestModel();
                request.obligationAmount = parseFloat(this.obligateAmount);
                request.obligationDate = new Date(this.obligateDate);
                request.obligationFundId = this.obligateTo;

                const api = new BankAccountsApi();
                const response: BankAccountObligateResponseModel = await api.obligateAsync(this.bankAccountId, this.$store.state.member.jwt, request);

                if ( response.depositFundBalance === 0 ) {
                    await this.$router.push({name: 'bankaccountdashboard', params: { bankAccountId: this.bankAccountId.toString(10)}});
                }
                else {
                    this.$store.dispatch('obligateRefresh', response);
                    this.obligateAmount = '';
                    this.obligateTo = 0;
                    this.resetFormValidation();
                }
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.obligateForm;

        return form.validate();
    }

    private resetFormValidation() {
        const form: any = this.$refs.obligateForm;

        form.resetValidation();
    }

}

